import { REPLACE_TAG_BUILDER_VALUE } from "../replace-wildcards.utils";

export const REPLACE_TAGS_MENU_OPTIONS = {
  title: "Replace Tags",
  menu: [
    {
      title: "Insert replace tag…",
      value: REPLACE_TAG_BUILDER_VALUE
    }
  ]
};
